import { Grid, Typography, Box } from "@mui/material";
import React from "react";

const informationData = [
  {
    id: 1,
    name: "Tell us about your business",
    description:
      "Share some basic info, like your venue name, location and opening hours",
  },
  {
    id: 2,
    name: "Stand out online",
    description:
      "Add images of your location and select some venue highlights to make your profile pop",
  },
  {
    id: 3,
    name: "Accept online bookings",
    description:
      "With a complete profile you're ready to start taking online bookings directly and on the Loba marketplace",
  },
];

const Information = () => {
  return (
    <Grid
      spacing={4}
      container
      sx={{ alignItems: "center", justifyContent: "center", marginTop: "40px" }}
    >
      <Grid item xs={12} sm={6} md={2}>
        <Typography variant="h3" sx={{ fontWeight: "700", fontSize: "21px" }}>
          Let's get you published on the world's{" "}
          <span style={{ color: "#EA580C" }}>most popular marketplace</span> to
          grow your business
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        {informationData.map((itemmmm) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: "700", fontSize: "16px" }}
                >
                  {itemmmm.id}
                </Typography>
                <Box sx={{ marginLeft: "10px", marginBottom: "20px" }}>
                  <Typography
                    variant="h3"
                    sx={{ fontWeight: "700", fontSize: "16px" }}
                  >
                    {itemmmm.name}
                  </Typography>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: "400",
                      fontSize: "14px",
                      marginTop: "10px",
                    }}
                  >
                    {itemmmm.description}
                  </Typography>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Information;
